module.exports = __webpack_public_path__ + "assets/img/prof_cheops_nothing.svg";